export class CreateDebitProcessing {
    id: string;
    modifiedby: string;
}